import localStorage from '../utils/local-storage'
import _ from 'lodash'
export const filtersToUlr = filters => {
  let queryString = "";
  for (const key in filters) {
    if (filters.hasOwnProperty(key)) {
      let value = "";
      if (typeof filters[key].value === "object") {
        value = filters[key].value.join(",");
      } else {
        value = filters[key].value;
      }
      if (value !== "" && value !== -1) {
        queryString += `&${key}=${value}`;
      }
    }
  }
  return queryString;
};

export const filtersToQueryString = (filters, getAll = false, getByPublishedAt = false) => {
  let queryString = "";
  for (const key in filters) {
    if (filters.hasOwnProperty(key)) {
      let value = "";
      if (typeof filters[key].value === "object") {
        value = filters[key].value.join(",");
      } else {
        value = filters[key].value;
      }
      if (value !== "" && value !== -1) {
        if (filters[key].fieldName === "_start") {
          if (getAll) {
            queryString += `&_start=0&_limit=-1`;
          } else {
            let numberPage = value >= 1 ? value - 1 : 0;
            let totalPerPage = filters.limit.value ? filters.limit.value : 20;
            queryString += `&_start=${numberPage * totalPerPage}`;
          }
        } else if (filters[key].fieldName === "publishedAt_lte" && !getByPublishedAt) {
          const newValue = moment(value).add(1, 'days').format();
          queryString += `&${filters[key].fieldName}=${newValue}`;
        } else {
          queryString += `&${filters[key].fieldName}=${value}`;
        }
      }
    }
  }
  return queryString;
};

export const buildCategoryDropDown = (categories, channels) => {

  let dataReturn = [];
  _.forEach(categories, (cat) => {
    const channel = (channels && channels.length > 0) ? channels.filter(obj => obj.increment_id === cat.channel) : null;
    const catname = cat.channel != 1 ? `[ ${(channel && channel.length > 0 && channel[0] && channel[0].label) ? channel[0].label : null} ] - ${cat.name}` : cat.name;
    let item = {
      "_id": cat._id,
      "status": cat.status,
      "is_root_category": cat.is_root_category,
      "name": cat.name,
      "label": catname,
      "url": cat.url,
      "createdAt": cat.createdAt,
      "updatedAt": cat.updatedAt,
      "editor_type": cat.editor_type,
      "channel": cat.channel,
      "id": cat.id
    }
    if (inYourCategory(item._id)) {
      dataReturn.push({ ...item, value: item })
    }
    if (cat.categories) {
      _.forEach(cat.categories, (cat1) => {
        if (cat1 && cat1.status) {
          let item = {
            "_id": cat1.id,
            "status": cat1.status,
            "is_root_category": cat1.is_root_category,
            "label": '----' + cat1.name,
            "name": cat1.name,
            "url": cat1.url,
            "createdAt": cat1.createdAt,
            "updatedAt": cat1.updatedAt,
            "editor_type": cat1.editor_type,
            "channel": cat.channel,
            "id": cat1.id
          };
          if (inYourCategory(item._id)) {
            dataReturn.push({ ...item, value: item })
          }

          if (cat1.categories) {
            _.forEach(cat1.categories, (cat2) => {
              let item = {
                "_id": cat2._id,
                "status": cat2.status,
                "is_root_category": cat2.is_root_category,
                "label": '--------' + cat2.name,
                "name": cat2.name,
                "url": cat2.url,
                "createdAt": cat2.createdAt,
                "updatedAt": cat2.updatedAt,
                "editor_type": cat2.editor_type,
                "channel": cat.channel,
                "id": cat2.id
              }
              if (inYourCategory(item._id)) {
                dataReturn.push({ ...item, value: item })
              }
            })
          }
        }

      })
    }
  })

  return dataReturn
}

function inYourCategory(idCat) {
  if ( window.location.pathname === '/videos') {
    return true;
  }
  return _.some(localStorage.get("_user").categories, { "_id": idCat });
}

export const buildCategoryManageDropDown = categories => {

  let dataReturn = [];
  _.forEach(categories, (cat) => {
    let item = {
      "_id": cat._id,
      "status": cat.status,
      "is_root_category": cat.is_root_category,
      "name": cat.name,
      "label": cat.name,
      "url": cat.url,
      "value": cat.id,
      "id": cat.id
    }
    dataReturn.push({ ...item, value: item })
    if (cat.categories) {
      _.forEach(cat.categories, (cat1) => {
        if (cat1) {
          let item = {
            "_id": cat1.id,
            "status": cat1.status,
            "is_root_category": cat1.is_root_category,
            "label": '----' + cat1.name,
            "name": cat1.name,
            "url": cat1.url,
            "value": cat1.id,
            "id": cat1.id
          };
          dataReturn.push({ ...item, value: item })
          if (cat1.categories) {
            _.forEach(cat1.categories, (cat2) => {
              let item = {
                "_id": cat2._id,
                "status": cat2.status,
                "is_root_category": cat2.is_root_category,
                "label": '--------' + cat2.name,
                "name": cat2.name,
                "url": cat2.url,
                "value": cat2.id,
                "id": cat2.id
              }
              dataReturn.push({ ...item, value: item })
            })
          }
        }

      })
    }
  })

  return dataReturn
}
